import { Action, createReducer, on } from '@ngrx/store';
import { SideBarStateEnum } from 'app/shared/layout/models/side-bar-state.enum';
import { WindowSizeModel } from 'app/shared/layout/services/window-size.model';
import { ProcessingPopupModel } from 'app/shared/popup/models/processing-popup.model';
import { ClientStatus } from 'app/shared/portal/models/client-status.model';

import {
  setClientStatus,
  setNavigationState,
  setSidebarLoadingState,
  setSidebarOpenState,
  setTermsId,
  setUserIdle,
  setWindowSizeChanged,
} from '../actions';

export interface UiState {
  photoUrl?: string;
  windowSize: WindowSizeModel;
  navState?: SideBarStateEnum;
  isSBarOpen: boolean;
  isSidebarLoading: boolean;
  isModalLoading: boolean;
  isUserIdle?: boolean;
  clientStatus?: ClientStatus;
  processingData?: ProcessingPopupModel;
  termsId?: number;
}

export interface Changed {
  changed: boolean;
}

const initialState: UiState = {
  photoUrl: '/assets/images/defaultPractitionerImage.jpg',
  windowSize: {
    width: document.documentElement.offsetWidth,
    height: document.documentElement.offsetHeight,
  },
  navState: SideBarStateEnum.Hidden,
  isSBarOpen: false,
  isSidebarLoading: false,
  isModalLoading: false,
  isUserIdle: false,
  clientStatus: undefined,
  processingData: undefined,
  termsId: 0,
};

const _uiReducer = createReducer(
  initialState,
  on(setWindowSizeChanged, (state, { windowSize }) => ({
    ...state,
    windowSize: windowSize,
  })),
  on(setNavigationState, (state, { navState }) => ({
    ...state,
    navState: navState,
  })),
  on(setSidebarOpenState, (state, { isSBarOpen }) => ({
    ...state,
    isSBarOpen: isSBarOpen,
  })),
  on(setSidebarLoadingState, (state, { isSidebarLoading }) => ({
    ...state,
    isSidebarLoading: isSidebarLoading,
  })),

  on(setUserIdle, (state, { isIdle }) => ({ ...state, isUserIdle: isIdle })),
  on(setClientStatus, (state, { clientStatus }) => ({
    ...state,
    clientStatus: clientStatus,
  })),
  on(setTermsId, (state, { termsId }) => ({
    ...state,
    termsId: termsId,
  }))
);

export function uiReducer(state: UiState | undefined, action: Action): UiState {
  return _uiReducer(state, action);
}

export const getUserPhotoUrl = (state: UiState): string | undefined => state?.photoUrl;
export const getWindowSizeChanged = (state: UiState): WindowSizeModel => state?.windowSize;
export const getNavigationState = (state: UiState): SideBarStateEnum | undefined => state?.navState;
export const getSidebarOpenState = (state: UiState): boolean => state?.isSBarOpen;
export const getSidebarLoadingState = (state: UiState): boolean => state?.isSidebarLoading;
export const getModalLoadingState = (state: UiState): boolean | undefined => state.isModalLoading;
export const getUserIdle = (state: UiState): boolean | undefined => state?.isUserIdle;
export const getClientStatus = (state: UiState): ClientStatus | undefined => state?.clientStatus;
export const getTermsId = (state: UiState): number | undefined => state?.termsId;
